import React, { useState } from 'react';
import { X } from 'lucide-react';

export default function PreviewBanner({ onApplyScholarship, onPayNow, onDismiss }) {
  const [isVisible, setIsVisible] = useState(true);

  const handleDismiss = () => {
    setIsVisible(false);
    if (onDismiss) onDismiss();
  };

  if (!isVisible) return null;

  return (
    <div className="relative bg-gradient-to-r from-[#1a4d5c] via-[#0d3640] to-[#1a4d5c] border-2 border-[#D4AF37] rounded-lg p-6 mb-8 shadow-2xl">
      {/* Close button */}
      <button
        onClick={handleDismiss}
        className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors"
        aria-label="Cerrar"
      >
        <X className="w-5 h-5" />
      </button>

      <div className="flex items-start gap-4">
        {/* Logo */}
        <div className="flex-shrink-0">
          <img 
            src="https://customer-assets.emergentagent.com/job_admin-portal-118/artifacts/5yseo6w0_Recurso%2026LOGO%20def.png"
            alt="Urpe School of Liberty"
            className="h-12 w-12 object-contain"
          />
        </div>

        {/* Content */}
        <div className="flex-1">
          <h3 className="text-lg font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#D4AF37] to-[#F4E4B7] mb-2">
            📖 Estás en modo vista previa
          </h3>
          <p className="text-gray-300 text-sm mb-4">
            Activa tu acceso para participar en sesiones en vivo, unirte a la comunidad exclusiva de WhatsApp y desbloquear todo el contenido del programa.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-3">
            <button
              onClick={onApplyScholarship}
              className="px-6 py-3 bg-gradient-to-r from-[#D4AF37] to-[#F4E4B7] text-black font-semibold rounded-lg hover:from-[#F4E4B7] hover:to-[#D4AF37] transition-all shadow-lg flex items-center justify-center gap-2"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              Aplicar Beca 50-100%
            </button>

            <button
              onClick={onPayNow}
              className="px-6 py-3 bg-white/10 border-2 border-[#D4AF37]/50 text-white font-semibold rounded-lg hover:bg-white/20 hover:border-[#D4AF37] transition-all flex items-center justify-center gap-2"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
              </svg>
              Pagar Ahora
            </button>
          </div>

          {/* Additional info */}
          <p className="text-xs text-gray-400 mt-3">
            💡 Con beca del 100%, solo pagas la inscripción de <span className="text-[#D4AF37] font-semibold">$497 USD</span>
          </p>
        </div>
      </div>
    </div>
  );
}
